import {
	Component,
	OnInit,
	ChangeDetectorRef,
	Input,
	Output,
	EventEmitter,
	ViewChild,
} from "@angular/core";
import { EducationFormService } from "./services/education-form.service";
import { HecResponse } from "../../shared-interfaces/hecResponse";
import { HEC_CONSTANTS } from "../../../utilities/constants";
import { SharedService } from "../../../shared/sharedServices/shared.service";
import { CommonHelper } from "../../../utilities/common.helper";
import { NgForm, Validators } from "@angular/forms";
import { decrypt, encrypt } from "../../../utilities/utilityFunctions";
import { LoaderService } from "../../sharedServices/loader.service";
import { NameService } from "../../../views/pages/das/services/name.service";
import { NameService as DesNameService } from "../../../views/pages/des/services/name.service";
import { Router } from "@angular/router";
import { PcdComponent } from "../../../views/pages/pcd/pcd.component";

@Component({
	selector: "kt-education-form",
	templateUrl: "./education-form.component.html",
	styleUrls: ["./education-form.component.scss"],
})
export class EducationFormComponent implements OnInit {
	// public educationDetailsData:any;
	@ViewChild("educationDetailsForm", { static: false })
	educationDetailsForm: NgForm;
	public loader: boolean = false;
	public todayDate = new Date();
	public selectedCountry: number;
	public selectedQualification: number;
	public qualId: any;
	public countryId: any;
	public instituteId: any;
	public gradingId: any;
	public qualificationLevel: any = [];
	public universityId: any;
	public totalMarksGpaPlaceHolder: string = "enter obtained CGPA";
	public totalMarksGpaDisplayName: string = "Obtained CGPA";
	public qualificationCode: any;
	public programId: any;
	public departmentId: any;
	public campusId: any;
	public degreeTypeId: any;
	public isAlertVisible: boolean = false;
	public alertClass: string;
	public alertIcon: string;
	public startDate: any;
	public endDate: any;
	public futureDate: Date = new Date(
		Date.now() + 3600 * 1000 * 24 * 7 * 30 * 365
	);
	public alertMsgValue: string;
	public isEduAlertVisible: boolean = false;
	public maxGpaValue: number = 0;
	public isEducationInComplete: boolean = false;
	public isCurrentlyEnrolled: boolean = false;
	public isMarksCorrect: boolean = false;
	public greaterThanOrEqualErrorMessage: string;
	public loggedInUserFullName: any;
	public isResearchWork: string = "false";
	public isResearchRequired: boolean;
	@Output() startDateUpdated = new EventEmitter();
	@Output() endDateUpdated = new EventEmitter();
	@Output() educationUpdated = new EventEmitter();
	@Output() cancelEducation = new EventEmitter();
	@Output() applicationIdNew = new EventEmitter();
	@Output() parentFunction = new EventEmitter();
	public dateOfBirth: any;
	@Input("formViewType") formViewType: any;
	@Input("isDesStream") isDesStream: boolean;
	@Input("desId") desId: any;
	public step = 0;
	@Input("educationDetailsData") educationDetailsData: any;
	@Input("dropdownList") dropdownList: any;
	@Input("onCampusDegree") onCampusDegree: any;
	@Input("passportAvailable") passportAvailable: any;
	@Input("applicationId") applicationId: any;
	public equalToErrorMessage;
	@Input("formType") formType: string;
	public isAnyEducationCurrentlyEnrolled: boolean = false;
	public currentlyEnrolledEducationName: string;
	public desUrls: any = HEC_CONSTANTS.DES_URLS;
	@Input("educationDetailGridData") educationDetailGridData;
	isPCD: boolean = false;
	pcdSubjectList: any = [];
	pcdSubjectSpecialization: number;
	isPCDSubject: any;
	@Input("pcdStatus") pcdStatus;
	@Input("pcdProfileId") pcdProfileId;
	/** DAS application payload — used to show per-degree `nameOnDegree` when editing. */
	@Input("dasApplicationData") dasApplicationData: any;
	constructor(
		private educationDetailsService: EducationFormService,
		private loaderService: LoaderService,
		private nameService: NameService,
		public router: Router,
		private cdr: ChangeDetectorRef,
		private sharedServices: SharedService,
		private desNameService: DesNameService
	) {
		let data = decrypt(localStorage.getItem("esp-profile-details"));
		data = JSON.parse(data);
		this.dateOfBirth = new Date(data.dob);
		this.loggedInUserFullName = this.getDefaultNameOnDegree();
	}

	private getDefaultNameOnDegree(): string {
		const fromService =
			this.nameService.getNameOnDegree() || this.desNameService.getNameOnDegree();
		return fromService != null && String(fromService).trim() !== ''
			? String(fromService).trim()
			: '';
	}

	/**
	 * Edit/view: prefer `dasApplicationDto.dasDegrees[].nameOnDegree` for the opened education.
	 * New / no match: keep profile NameService default.
	 */
	private applyNameOnDegreeDisplay(educationRow: any, formView: string): void {
		if (formView === 'edit' || formView === 'view') {
			const fromDasDegree = this.getNameOnDegreeFromDasDegrees(educationRow);
			if (fromDasDegree) {
				this.loggedInUserFullName = fromDasDegree;
				return;
			}
		}
		this.loggedInUserFullName = this.getDefaultNameOnDegree();
	}

	private getNameOnDegreeFromDasDegrees(educationRow: any): string | null {
		const degrees =
			this.dasApplicationData &&
			this.dasApplicationData.dasApplicationDto &&
			Array.isArray(this.dasApplicationData.dasApplicationDto.dasDegrees)
				? this.dasApplicationData.dasApplicationDto.dasDegrees
				: [];
		if (!degrees.length || !educationRow) {
			return null;
		}

		const eduId =
			educationRow.educationId != null && educationRow.educationId !== ''
				? Number(educationRow.educationId)
				: null;
		const historyId =
			educationRow.eduationHistoryId != null && educationRow.eduationHistoryId !== ''
				? Number(educationRow.eduationHistoryId)
				: educationRow.educationHistoryId != null && educationRow.educationHistoryId !== ''
				? Number(educationRow.educationHistoryId)
				: null;

		for (let i = 0; i < degrees.length; i++) {
			const degree = degrees[i];
			if (!degree) {
				continue;
			}
			const dto = degree.educationHistoryDto;
			const degreeEduId =
				dto && dto.educationId != null && dto.educationId !== ''
					? Number(dto.educationId)
					: null;
			const degreeHistoryId =
				degree.cpEducationHistoryId != null && degree.cpEducationHistoryId !== ''
					? Number(degree.cpEducationHistoryId)
					: dto && dto.eduationHistoryId != null && dto.eduationHistoryId !== ''
					? Number(dto.eduationHistoryId)
					: dto && dto.educationHistoryId != null && dto.educationHistoryId !== ''
					? Number(dto.educationHistoryId)
					: null;

			const eduMatch =
				eduId != null && !isNaN(eduId) && degreeEduId != null && !isNaN(degreeEduId) && eduId === degreeEduId;
			const historyMatch =
				historyId != null &&
				!isNaN(historyId) &&
				degreeHistoryId != null &&
				!isNaN(degreeHistoryId) &&
				historyId === degreeHistoryId;

			if (eduMatch || historyMatch) {
				if (degree.nameOnDegree != null && String(degree.nameOnDegree).trim() !== '') {
					return String(degree.nameOnDegree).trim();
				}
				return null;
			}
		}
		return null;
	}

	async ngOnInit() {
		//syntax updated and added in constructor
		//this.dateOfBirth  =  new Date(+decrypt(localStorage.getItem(('dob'))))
		console.log(this.applicationId);
		console.log(this.dropdownList);

		if (
			this.router.url == "/pcd" ||
			this.router.url == "/controller" ||
			this.router.url == "/pcd-admin"
		) {
			this.isPCD = true;
			this.cdr.detectChanges();
		}

		if (this.desUrls.FOREIGN_DES !== this.router.url) {
			console.log(this.educationDetailGridData);
			for (let i = 0; i < this.educationDetailGridData.length; i++) {
				if (
					this.educationDetailGridData[i] &&
					this.educationDetailGridData[i].currentEnrolmentInd &&
					this.educationDetailGridData[i].educationId !=
						this.educationDetailsData.educationId
				) {
					this.currentlyEnrolledEducationName =
						this.educationDetailGridData[i].qualificationLevel;
					this.isAnyEducationCurrentlyEnrolled = true;
				}
			}
		}
		this.dropdownList.gpaList = [
			{ label: "4.0", value: 4 },
			{ label: "5.0", value: 5 },
		];
		if (this.desUrls.FOREIGN_DES === this.router.url) {
			await this.getDesForeignEducationLists();
		} else {
			await this.getQualificationLevel();
		}
		this.openEducationDetails(this.educationDetailsData, this.formViewType);
	

		if (this.applicationId != null && this.isPCD) {
			this.getPcdSubject();
		}
		if(this.isPCD)
		{
			this.getPcdSubjectList();
		}
		console.log("formType cgppa", this.formType);
		
		
	}

	public isPcdIscedQualification(): boolean {
		return this.isPCD && (this.qualId == 12 || this.qualId == 19);
	}

	private getIscedValidationMessage(): string {
		return "Please select subject in accordance with UNESCO (ISCED) Subject Specialization";
	}

	private isMissingIscedSubject(subjectId: any): boolean {
		return (
			subjectId === null ||
			subjectId === undefined ||
			String(subjectId).trim() === ""
		);
	}
	public getQualificationLevel() {
		console.log(this.desId);
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.cdr.detectChanges();

		return new Promise((resolve, reject) => {
			this.educationDetailsService
				.getQualificationLevel()
				.subscribe((res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (this.formType == "cp") {
							this.qualificationLevel = res.data;
						} else if (
							this.formType == HEC_CONSTANTS.ACRONYM_TYPES.DAS
						) {
							for (let i = 0; i < res.data.length; i++) {
								if (
									res.data[i].value != 7 &&
									res.data[i].value != 8 &&
									res.data[i].value != 18
								) {
									this.qualificationLevel.push(res.data[i]);
								} else {
								}
							}
						} else if (
							this.formType ==
							HEC_CONSTANTS.ACRONYM_TYPES.LOCAL_DES
						) {
							// this.dropdownList.countryList = []
							// this.dropdownList.countryList.push({label:'Pakistan',value:1})
							this.qualificationLevel = [];
							for (let i = 0; i < res.data.length; i++) {
								if (this.isDesStream) {
									this.qualificationLevel.push({
										label: this.desId.label,
										value: this.desId.id,
									});
									return;
								} else if (
									res.data[i].value != 7 &&
									res.data[i].value != 8 &&
									res.data[i].value != 18
								) {
									this.qualificationLevel.push(res.data[i]);
								}
							}
						} else if (
							this.formType ==
							HEC_CONSTANTS.ACRONYM_TYPES.FOREIGN_DES
						) {
							// for(let countryInd=0; countryInd <= this.dropdownList.countryList.length;countryInd++){
							//   if(this.dropdownList.countryList[countryInd].value == 1){
							//     delete this.dropdownList.countryList[countryInd]
							//   }
							// }
							//this.dropdownList.countryList.splice(138, 1);
							var indexOfPakistan =
								this.dropdownList.countryList.findIndex(
									(d) => d.value == 1
								); //not required for foreign education
							// this.dropdownList.countryList.splice(
							// 	indexOfPakistan,
							// 	1
							// );
							this.qualificationLevel = [];
							for (let i = 0; i < res.data.length; i++) {
								if (this.isDesStream) {
									this.qualificationLevel.push({
										label: this.desId.label,
										value: this.desId.id,
									});
									return;
								} else if (
									res.data[i].value != 7 &&
									res.data[i].value != 8 &&
									res.data[i].value != 18
								) {
									this.qualificationLevel.push(res.data[i]);
								}
							}
						}
						resolve(this.qualificationLevel);
						this.cdr.detectChanges();
					}
				});
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityListByCountryForAboveHSC(countryId) {
		return new Promise((resolve, reject) => {
			if (countryId != undefined) {
				this.educationDetailsService
					.getUniversityListByCountryForAboveHSC(countryId)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								if (
									this.desUrls.FOREIGN_DES === this.router.url
								) {
									res.data = res.data.filter(function (obj) {
										return obj.label !== "Other";
									});
									this.dropdownList.degreeInstituteList =
										res.data;
									resolve(
										this.dropdownList.degreeInstituteList
									);
								} else {
									this.dropdownList.degreeInstituteList =
										res.data;
									resolve(
										this.dropdownList.degreeInstituteList
									);
								}

								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityListByCountryForBelowHSC(countryId, qualificationId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (countryId != undefined) {
				this.educationDetailsService
					.getUniversityListByCountryForBelowHSC(
						countryId,
						qualificationId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.degreeInstituteListByBoard =
									res.data;
								resolve(
									this.dropdownList.degreeInstituteListByBoard
								);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityDegreeProgramForNonHSCorSSC(
		universityId,
		qualificationId
	) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityDegreeProgramForNonHSCorSSC(
						universityId,
						qualificationId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.degreeProgramList = res.data;
								resolve(this.dropdownList.degreeProgramList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getDicsiplineListByQualId(qualificationId) {
		this.dropdownList.disciplineList = [];
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (qualificationId != undefined) {
				if (qualificationId == 7) {
					this.dropdownList.disciplineList = [
						{ label: "Arts", value: 11926 },
						{ label: "Commerce", value: 11927 },
						{ label: "Science", value: 11928 },
						{ label: "Technical", value: 11929 },
						{ label: "O-level", value: 11930 },
					];
				}
				this.educationDetailsService
					.getDicsiplineListByQualId(qualificationId)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.disciplineList = res.data;
								resolve(this.dropdownList.disciplineList);
								this.cdr.detectChanges();
								this.cdr.markForCheck();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getDegreeProdgramListHSCorSSC(universityId, qualificationId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityDegreeProgramListForHSCorSSC(
						universityId,
						qualificationId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.degreeProgramList = res.data;
								resolve(this.dropdownList.degreeProgramList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityNameOnDegree(universityId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityChangeNames(universityId)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.universityNameList = res.data;
								resolve(this.dropdownList.universityNameList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getDataFromUniversityDegreeProgram(programId) {
		this.programId = programId;
		this.clearCampusAndDepartmentSelections();
		this.getUniversityCampuses(this.qualId, this.instituteId, programId);
	}

	private resolveUniversityDegreeProgramId(source?: any): any {
		const data = source || this.educationDetailsData || {};
		if (this.programId !== undefined && this.programId !== null && this.programId !== '') {
			return this.programId;
		}
		if (data.degreeProgramId !== undefined && data.degreeProgramId !== null && data.degreeProgramId !== '') {
			return data.degreeProgramId;
		}
		if (
			data.universityDegreeProgramId !== undefined &&
			data.universityDegreeProgramId !== null &&
			data.universityDegreeProgramId !== ''
		) {
			return data.universityDegreeProgramId;
		}
		const formValue =
			this.educationDetailsForm && this.educationDetailsForm.form
				? this.educationDetailsForm.form.value
				: null;
		if (
			formValue &&
			formValue.universityDegreeProgramId !== undefined &&
			formValue.universityDegreeProgramId !== null &&
			formValue.universityDegreeProgramId !== ''
		) {
			return formValue.universityDegreeProgramId;
		}
		return null;
	}

	/** Reset campus / department when program title changes so user picks fresh dependent values. */
	private clearCampusAndDepartmentSelections(): void {
		this.campusId = null;
		this.departmentId = null;
		this.dropdownList.departmentList = [];

		if (this.educationDetailsData) {
			this.educationDetailsData.campusId = null;
			this.educationDetailsData.universityDepartmentId = null;
		}

		const form =
			this.educationDetailsForm && this.educationDetailsForm.form
				? this.educationDetailsForm.form
				: null;
		if (!form || !form.controls) {
			this.cdr.detectChanges();
			return;
		}

		if (form.controls.campusId) {
			form.controls.campusId.reset();
		}
		if (form.controls.universityDepartmentId) {
			form.controls.universityDepartmentId.reset();
		}
		if (form.controls.otherCampus) {
			form.controls.otherCampus.reset();
		}
		if (form.controls.otherDepartmentName) {
			form.controls.otherDepartmentName.reset();
		}
		this.cdr.detectChanges();
	}

	public getDataFromUniversityCampus(campusId) {
		this.campusId = campusId;
		const universityDegreeProgramId = this.resolveUniversityDegreeProgramId();
		this.programId = universityDegreeProgramId;
		this.clearDepartmentSelection();
		this.getUniversityDepartments(
			this.qualId,
			this.instituteId,
			universityDegreeProgramId,
			campusId
		);
	}

	/** Campus controls department options, so old department selection is invalid after campus changes. */
	private clearDepartmentSelection(): void {
		this.departmentId = null;
		this.dropdownList.departmentList = [];

		if (this.educationDetailsData) {
			this.educationDetailsData.universityDepartmentId = null;
		}

		const form =
			this.educationDetailsForm && this.educationDetailsForm.form
				? this.educationDetailsForm.form
				: null;
		if (!form || !form.controls) {
			this.cdr.detectChanges();
			return;
		}

		if (form.controls.universityDepartmentId) {
			form.controls.universityDepartmentId.reset();
			form.controls.universityDepartmentId.setErrors({ required: true });
			form.controls.universityDepartmentId.markAsTouched();
		}
		this.cdr.detectChanges();
	}

	public getDataFromUniversityDepartment(departmentId) {
		this.departmentId = departmentId;
		const universityDegreeProgramId = this.resolveUniversityDegreeProgramId();
		this.programId = universityDegreeProgramId;
		this.getUniversityDegreeTypes(
			this.qualId,
			this.instituteId,
			universityDegreeProgramId,
			this.campusId,
			departmentId
		);
	}

	public getDataFromUniversityDegreeType(degreeTypeId) {
		this.degreeTypeId = degreeTypeId;
		if (this.countryId == 1) {
			const universityDegreeProgramId = this.resolveUniversityDegreeProgramId();
			this.programId = universityDegreeProgramId;
			this.getUniversitySessionsList(
				this.qualId,
				this.instituteId,
				universityDegreeProgramId,
				this.campusId,
				this.departmentId,
				degreeTypeId
			);
		}
	}

	public getUniversityCampuses(
		qualificationId,
		universityId,
		universityDegreeProgramId
	) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityCampus(
						qualificationId,
						universityId,
						universityDegreeProgramId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.campusList = res.data;
								resolve(this.dropdownList.campusList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityDepartments(
		qualificationId,
		universityId,
		universityDegreeProgramId,
		campusId
	) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityDepartments(
						qualificationId,
						universityId,
						universityDegreeProgramId,
						campusId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.departmentList = res.data;
								resolve(this.dropdownList.departmentList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversityDegreeTypes(
		qualificationId,
		universityId,
		universityDegreeProgramId,
		campusId,
		departmentId
	) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversityDegreeType(
						qualificationId,
						universityId,
						universityDegreeProgramId,
						campusId,
						departmentId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.degreeTypesList = res.data;
								resolve(this.dropdownList.degreeTypesList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getUniversitySessionsList(
		qualificationId,
		universityId,
		universityDegreeProgramId,
		campusId,
		departmentId,
		degreeTypeId
	) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (universityId != undefined) {
				this.educationDetailsService
					.getUniversitySessions(
						qualificationId,
						universityId,
						universityDegreeProgramId,
						campusId,
						departmentId,
						degreeTypeId
					)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.sessionTypesList = res.data;
								resolve(this.dropdownList.sessionTypesList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getEducationMajorList(disciplineId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (disciplineId != undefined) {
				this.educationDetailsService
					.getEducationMajorList(disciplineId)
					.subscribe(
						(res: HecResponse) => {
							if (
								res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK
							) {
								this.dropdownList.majorList = res.data;
								resolve(this.dropdownList.majorList);
								this.cdr.detectChanges();
							} else {
							}
						},
						(err) => {}
					);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getCitiesByCountry(countryId) {
		return new Promise((resolve, reject) => {
			// this.selectedCountryId = countryId;
			if (countryId != undefined) {
				this.sharedServices.getCitiesByCountryId(countryId).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.dropdownList.cityList = res.data;
							resolve(this.dropdownList.cityList);
							this.cdr.detectChanges();
						} else {
						}
					},
					(err) => {}
				);
			}
		}).catch(function (error) {
			console.log(error);
		});
	}

	public async openEducationDetails(data, type) {
		this.formViewType = type;
		if (this.desUrls.FOREIGN_DES !== this.router.url) {
			this.getSelectedQualificationLevel(data.qualificationId);
			this.getIncompleteEduStatus(data.isIncompleteEducation);
			this.getCurrentlyEnrolledStatus(data.currentEnrolmentInd);
			await this.getSelectedCountryId(data.countryId);
		} else if (this.desUrls.FOREIGN_DES === this.router.url) {
			await this.getSelectedCountryId(data.country);
			this.getSelectedQualificationLevel(data.qualification);
		}
		// this.getSelectedQualificationLevel(data.qualificationId)
		await this.getSelectedInstitutId(data.universityId);

		if (data.countryId == 1) {
			const universityDegreeProgramId = this.resolveUniversityDegreeProgramId(data);
			this.programId = universityDegreeProgramId;
			await this.getUniversityCampuses(
				data.qualificationId,
				data.universityId,
				universityDegreeProgramId
			);
			if (data.qualificationId != 7 && data.qualificationId != 8) {
				await this.getUniversityDepartments(
					data.qualificationId,
					data.universityId,
					universityDegreeProgramId,
					data.campusId
				);

				await this.getUniversityDegreeTypes(
					data.qualificationId,
					data.universityId,
					universityDegreeProgramId,
					data.campusId,
					data.universityDepartmentId
				);
				await this.getUniversitySessionsList(
					data.qualificationId,
					data.universityId,
					universityDegreeProgramId,
					data.campusId,
					data.universityDepartmentId,
					data.degreeTypeId
				);
			}
		} else {
			await this.getEducationMajorList(data.subjectId);
			this.dropdownList.degreeTypesList =
				this.dropdownList.degreeTypeList;
			this.dropdownList.sessionTypesList =
				this.dropdownList.sessionTypeList;
		}
		this.getSelectedGpaValue(data.totalCGPAMarks, "get");
		if (data.qualificationId != 7 && data.qualificationId != 8) {
			this.getGradingType(data.gradingSystemCodeId);
		} else {
			this.gradingId == 10543;
		}
		await this.getUniversityNameOnDegree(data.universityId);
		data.startDate = data.startDate;
		data.endDate = data.endDate;
		if (this.educationDetailGridData.length > 1) {
			this.getDateValue(
				new Date(data.startDate).getFullYear() +
					"-" +
					(new Date(data.startDate).getMonth() + 1) +
					"-" +
					new Date(data.startDate).getDate(),
				"start",
				undefined,
				"get"
			);
		}
		// this.getDateValue((new Date(data.endDate).getFullYear() +'-'+(new Date(data.endDate).getMonth()+1)+'-'+new Date(data.endDate).getDate()),'end')
		this.educationDetailsData = data;
		this.applyNameOnDegreeDisplay(data, type);
		// this.newEducationAddFormDisplay = true;
		this.loader = false;
		this.loaderService.setValue(this.loader);
		this.cdr.markForCheck();
		this.cdr.detectChanges();
	}

	public async getSelectedInstitutId(instituteId, type?) {
		this.instituteId = instituteId;
		if (type) {
			this.dropdownList.campusList = [];
			this.dropdownList.degreeProgramList = [];

			if (this.educationDetailsForm.form.controls.campusId)
				this.educationDetailsForm.form.controls.campusId.reset();
			if (this.educationDetailsForm.form.controls.otherCampus)
				this.educationDetailsForm.form.controls.otherCampus.reset();
			if (this.educationDetailsForm.form.controls.universityDepartmentId)
				this.educationDetailsForm.form.controls.universityDepartmentId.reset();
			if (this.educationDetailsForm.form.controls.otherDepartmentName)
				this.educationDetailsForm.form.controls.otherDepartmentName.reset();
			if (this.educationDetailsForm.form.controls.degreeTypeId)
				this.educationDetailsForm.form.controls.degreeTypeId.reset();
			if (this.educationDetailsForm.form.controls.sessionTypeId)
				this.educationDetailsForm.form.controls.sessionTypeId.reset();
			if (this.educationDetailsForm.form.controls.specializationSubjectId)
				this.educationDetailsForm.form.controls.specializationSubjectId.reset();
			if (this.educationDetailsForm.form.controls.isResearchWork)
				this.educationDetailsForm.form.controls.isResearchWork.reset();
			if (
				this.educationDetailsForm.form.controls.universityNameOnDegreeId
			)
				this.educationDetailsForm.form.controls.universityNameOnDegreeId.reset();
			if (this.educationDetailsForm.form.controls.isFcpsDegree)
				this.educationDetailsForm.form.controls.isFcpsDegree.reset();
		}
		if (this.qualId != 7 && this.qualId != 8 && this.countryId == 1) {
			await this.getUniversityDegreeProgramForNonHSCorSSC(
				this.instituteId,
				this.qualId
			);
		} else {
			await this.getDegreeProdgramListHSCorSSC(
				this.instituteId,
				this.qualId
			);
		}
		await this.getUniversityNameOnDegree(instituteId);
	}

	public getSelectedQualificationLevel(qualId, type?) {
		console.log(qualId);
		if (type == "update") {
			if (this.desUrls.FOREIGN_DES !== this.router.url) {
				this.dropdownList.campusList = [];
				this.dropdownList.degreeInstituteList = [];
				this.dropdownList.degreeProgramList = [];
				this.dropdownList.disciplineList = [];
				this.dropdownList.universityNameList = [];
				this.educationDetailsForm.form.controls.countryId.reset();
				if (this.educationDetailsForm.form.controls.cityId) {
					this.educationDetailsForm.form.controls.cityId.reset();
					this.isResearchWork = "false";
				}
				if (this.educationDetailsForm.form.controls.universityId)
					this.educationDetailsForm.form.controls.universityId.reset();
				if (
					this.educationDetailsForm.form.controls
						.schoolCollegeDepartmentName
				)
					this.educationDetailsForm.form.controls.schoolCollegeDepartmentName.reset();
				if (this.educationDetailsForm.form.controls.sectorCode)
					this.educationDetailsForm.form.controls.sectorCode.reset();
				if (
					this.educationDetailsForm.form.controls
						.universityDegreeProgramId
				)
					this.educationDetailsForm.form.controls.universityDegreeProgramId.reset();
				if (this.educationDetailsForm.form.controls.otherProgramTitle)
					this.educationDetailsForm.form.controls.otherProgramTitle.reset();
				if (this.educationDetailsForm.form.controls.subjectId)
					this.educationDetailsForm.form.controls.subjectId.reset();
				if (this.educationDetailsForm.form.controls.otherUniversity)
					this.educationDetailsForm.form.controls.otherUniversity.reset();
				if (
					this.educationDetailsForm.form.controls
						.universityNameOnDegreeId
				)
					this.educationDetailsForm.form.controls.universityNameOnDegreeId.reset();
				if (this.educationDetailsForm.form.controls.campusId)
					this.educationDetailsForm.form.controls.campusId.reset();
				if (this.educationDetailsForm.form.controls.otherCampus)
					this.educationDetailsForm.form.controls.otherCampus.reset();
				if (
					this.educationDetailsForm.form.controls
						.universityDepartmentId
				)
					this.educationDetailsForm.form.controls.universityDepartmentId.reset();
				if (this.educationDetailsForm.form.controls.otherDepartmentName)
					this.educationDetailsForm.form.controls.otherDepartmentName.reset();
				if (this.educationDetailsForm.form.controls.degreeTypeId)
					this.educationDetailsForm.form.controls.degreeTypeId.reset();
				if (this.educationDetailsForm.form.controls.sessionTypeId)
					this.educationDetailsForm.form.controls.sessionTypeId.reset();
				if (
					this.educationDetailsForm.form.controls
						.specializationSubjectId
				)
					this.educationDetailsForm.form.controls.specializationSubjectId.reset();
				if (this.educationDetailsForm.form.controls.isResearchWork)
					this.educationDetailsForm.form.controls.isResearchWork.reset();
				if (this.educationDetailsForm.form.controls.areaResearch)
					this.educationDetailsForm.form.controls.areaResearch.reset();
				if (this.educationDetailsForm.form.controls.gradingSystemCodeId)
					this.educationDetailsForm.form.controls.gradingSystemCodeId.reset();
				if (this.educationDetailsForm.form.controls.registrationNumber)
					this.educationDetailsForm.form.controls.registrationNumber.reset();
				if (this.educationDetailsForm.form.controls.examSystemTypeCode)
					this.educationDetailsForm.form.controls.examSystemTypeCode.reset();
				if (this.educationDetailsForm.form.controls.totalCGPAMarks)
					this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
				if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
					this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
				if (this.educationDetailsForm.form.controls.obtainedPercentage)
					this.educationDetailsForm.form.controls.obtainedPercentage.reset();
				if (this.educationDetailsForm.form.controls.pcdNumber)
					this.educationDetailsForm.form.controls.pcdNumber.reset();
			} else if (this.desUrls.FOREIGN_DES === this.router.url) {
				if (this.educationDetailsForm.form.controls.startDate)
					this.educationDetailsForm.form.controls.startDate.reset();
				if (this.educationDetailsForm.form.controls.endDate)
					this.educationDetailsForm.form.controls.endDate.reset();
				if (this.educationDetailsForm.form.controls.country)
					this.educationDetailsForm.form.controls.country.reset();
				if (this.educationDetailsForm.form.controls.university)
					this.educationDetailsForm.form.controls.university.reset();
				if (this.educationDetailsForm.form.controls.campus)
					this.educationDetailsForm.form.controls.campus.reset();
				if (this.educationDetailsForm.form.controls.department)
					this.educationDetailsForm.form.controls.department.reset();
				if (this.educationDetailsForm.form.controls.modeOfStudy)
					this.educationDetailsForm.form.controls.modeOfStudy.reset();
				if (this.educationDetailsForm.form.controls.rollNo)
					this.educationDetailsForm.form.controls.rollNo.reset();
				if (this.educationDetailsForm.form.controls.otherProgramTitle)
					this.educationDetailsForm.form.controls.otherProgramTitle.reset();
				if (this.educationDetailsForm.form.controls.otherUniversity)
					this.educationDetailsForm.form.controls.otherUniversity.reset();
				if (this.educationDetailsForm.form.controls.major)
					this.educationDetailsForm.form.controls.major.reset();
				if (this.educationDetailsForm.form.controls.sessionType)
					this.educationDetailsForm.form.controls.sessionType.reset();
				if (this.educationDetailsForm.form.controls.degreeObtainedBy)
					this.educationDetailsForm.form.controls.degreeObtainedBy.reset();
				if (this.educationDetailsForm.form.controls.researchTitle)
					this.educationDetailsForm.form.controls.researchTitle.reset();
				if (qualId == 6003510) {
					this.sharedServices
						.openPopupDialog(
							HEC_CONSTANTS.SERVICES_TYPES.FOREIGN_DES,
							"Instruction will be provided by DESF Team",
							HEC_CONSTANTS.ERROR_TYPES.info
						)
						.then((res) => {
							if (res) {
							}
						});
				}
			}
		}
		this.qualId = qualId;
		if (this.qualId == 7 || this.qualId == 8) {
			this.gradingId = 10543;
			this.totalMarksGpaDisplayName = "Obtained Marks";
			this.totalMarksGpaPlaceHolder = "enter obtained Marks";
		} else {
			this.gradingId = undefined;
		}
	}

	public async getSelectedCountryId(countryId) {
		if (this.desUrls.FOREIGN_DES !== this.router.url) {
			this.countryId = countryId;
			if (this.educationDetailsForm.form.controls.subjectId)
				this.educationDetailsForm.form.controls.subjectId.reset();
			for (let i = 0; i < this.qualificationLevel.length; i++) {
				if (this.qualificationLevel[i].id == this.qualId) {
					this.qualificationCode =
						this.qualificationLevel[i].levelCodeId;
				}
			}
			await this.getDicsiplineListByQualId(this.qualId);
			await this.getCitiesByCountry(countryId);
			if (countryId == 1 && (this.qualId == 7 || this.qualId == 8)) {
				await this.getUniversityListByCountryForBelowHSC(
					countryId,
					this.qualificationCode
				);
			} else {
				await this.getUniversityListByCountryForAboveHSC(countryId);
			}
		} else if (this.desUrls.FOREIGN_DES === this.router.url) {
			await this.getDicsiplineListByQualId(10);
			await this.getUniversityListByCountryForAboveHSC(countryId);
		}
		if (countryId != 1) {
			if (this.desUrls.FOREIGN_DES !== this.router.url) {
				this.dropdownList.degreeTypesList =
					this.dropdownList.degreeTypeList;
				this.dropdownList.sessionTypesList =
					this.dropdownList.sessionTypeList;
			}
		}
	}

	public getGradingType(gradingId) {
		this.gradingId = gradingId;
		if (gradingId == 10541) {
			this.totalMarksGpaDisplayName = "Obtained CGPA";
			this.totalMarksGpaPlaceHolder = "enter obtained CGPA";
		} else if (gradingId == 10543) {
			this.totalMarksGpaDisplayName = "Obtained Marks";
			this.totalMarksGpaPlaceHolder = "enter obtained Marks";
		}
	}

	public getSelectedGpaValue(gpaValue, type?) {
		this.maxGpaValue = gpaValue;
		if (type == undefined) {
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
		}
		this.cdr.detectChanges();
	}

	public getObtainedMarksGpaValue(event) {
		if (+event.target.value > +this.maxGpaValue) {
			this.isMarksCorrect = false;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors(
				{ max: true }
			);
		} else if (+event.target.value < 0) {
			this.isMarksCorrect = false;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors(
				{ min: true }
			);
		} else {
			this.isMarksCorrect = true;
			this.educationDetailsForm.form.controls.obtainedCGPAMarks.setErrors(
				null
			);
		}
	}

	public getDateValue(date, field, eduId?, formtype?) {
		if (field == "end" && String(date) == String(this.startDate)) {
			this.greaterThanOrEqualErrorMessage =
				HEC_CONSTANTS.MESSGAES_LIST.educationalMessages.END_DATE_GREATER;
			this.cdr.detectChanges();
		}
		if (field == "start") {
			this.startDate = new Date(date);
			this.cdr.detectChanges();
		}

		if (field == "start" && formtype == undefined) {
			this.educationDetailsForm.form.controls.endDate.reset();
		}
		// if(this.formViewType != 'view'){
		//   for (let i = 0; i < this.educationDetailGridData.length; i++) {
		//     let check = new Date(date).getFullYear() +'-'+ new Date(date).getMonth() +'-'+ new Date(date).getDate()
		//     let from =  new Date(this.educationDetailGridData[i].startDate).getFullYear()+'-'+ new Date(this.educationDetailGridData[i].startDate).getMonth() +'-'+ new Date(this.educationDetailGridData[i].startDate).getDate()
		//     let to = new Date(this.educationDetailGridData[i].endDate).getFullYear()+'-'+ new Date(this.educationDetailGridData[i].endDate).getMonth() +'-'+ new Date(this.educationDetailGridData[i].endDate).getDate()
		//     if (check > from && check < to && eduId != this.educationDetailGridData[i].educationId) {
		//       this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		//       this.alertBoxMsg('Your current date selection overlaps the duration of your '+ this.equalToErrorMessage+' education. Please change your date selection.')
		//       this.isEduAlertVisible = true;
		//       this.cdr.detectChanges();
		//       if( field=='start'){
		//       this.educationDetailsForm.form.controls.startDate.setErrors({equalTo: true});
		//       if(this.formViewType == 'edit'){
		//         this.markFormsTouched(this.educationDetailsForm)
		//       }
		//       this.cdr.detectChanges();
		//       return;
		//     }else if(field=='end'){
		//       this.endDate = date;
		//       this.educationDetailsForm.form.controls.endDate.setErrors({equalTo: true});
		//       return;
		//     }
		//   }else if(field=='start' && (new Date(this.startDate)<new Date(this.educationDetailGridData[i].startDate) &&
		//   new Date(this.educationDetailGridData[i].endDate) < new Date(this.endDate))  && eduId != this.educationDetailGridData[i].educationId){
		//     this.educationDetailsForm.form.controls.endDate.setErrors({equalTo: true});
		//     this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		//     this.alertBoxMsg('Your current date selection overlaps the duration of your '+ this.equalToErrorMessage+' education. Please change your date selection.')
		//     this.isEduAlertVisible = true;
		//     return;

		//   }
		//   else if(field=='end' && (new Date(this.startDate)<new Date(this.educationDetailGridData[i].startDate) &&
		//   new Date(this.educationDetailGridData[i].endDate) < new Date(date)) && eduId != this.educationDetailGridData[i].educationId){
		//     this.educationDetailsForm.form.controls.endDate.setErrors({equalTo: true});
		//     this.equalToErrorMessage = this.educationDetailGridData[i].qualificationLevel;
		//     this.alertBoxMsg('Your current date selection overlaps the duration of your '+ this.equalToErrorMessage+' education. Please change your date selection.')
		//     this.isEduAlertVisible = true;
		//     return;
		//   }
		//   else{
		//     this.isEduAlertVisible = false;
		//     this.cdr.detectChanges();
		//   }
		// }
		// }
	}

	public getResearchWork(event) {
		console.log(this.educationDetailsForm.value.isResearchWork);
		this.isResearchWork = this.educationDetailsForm.value.isResearchWork;
	}

	public cancelContact() {
		this.cancelEducation.emit("cancel");
	}

	setStep(index: number) {
		this.step = index;
	}

	nextStep() {
		this.step++;
	}

	prevStep() {
		this.step--;
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === "VALID") {
			return true;
		}
	}

	private isUniversityDepartmentRequired(): boolean {
		return this.countryId == 1 && this.qualId != 7 && this.qualId != 8;
	}

	private isMissingUniversityDepartment(): boolean {
		if (!this.isUniversityDepartmentRequired()) {
			return false;
		}
		const value =
			this.educationDetailsForm &&
			this.educationDetailsForm.value
				? this.educationDetailsForm.value.universityDepartmentId
				: null;
		return value === null || value === undefined || value === '';
	}

	private enforceUniversityDepartmentRequired(): boolean {
		if (!this.isMissingUniversityDepartment()) {
			return true;
		}
		const control =
			this.educationDetailsForm &&
			this.educationDetailsForm.form &&
			this.educationDetailsForm.form.controls
				? this.educationDetailsForm.form.controls.universityDepartmentId
				: null;
		if (control) {
			control.setErrors({ required: true });
			control.markAsTouched();
		}
		this.alertBoxMsg(
			HEC_CONSTANTS.MESSGAES_LIST.educationalMessages.MANDATORY_MSG
		);
		this.isAlertVisible = true;
		this.cdr.detectChanges();
		return false;
	}

	public getIncompleteEduStatus(event, type?) {
		this.isEducationInComplete = event;
		this.isCurrentlyEnrolled = false;
		if (type) {
			this.educationDetailsData.currentEnrolmentInd = undefined;
			this.educationDetailsForm.form.controls.currentEnrolmentInd.reset();
		}
	}

	public getCurrentlyEnrolledStatus(event, type?) {
		this.isCurrentlyEnrolled = event;
		if ((event && type != undefined) || (!event && type != undefined)) {
			this.educationDetailsForm.form.controls.endDate.reset();
			if (this.educationDetailsForm.form.controls.totalCGPAMarks)
				this.educationDetailsForm.form.controls.totalCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedCGPAMarks)
				this.educationDetailsForm.form.controls.obtainedCGPAMarks.reset();
			if (this.educationDetailsForm.form.controls.obtainedPercentage)
				this.educationDetailsForm.form.controls.obtainedPercentage.reset();
		}
	}

	public saveEducation() {
		console.log(this.educationDetailsForm);
		this.markFormsTouched(this.educationDetailsForm);

		if (!this.enforceUniversityDepartmentRequired()) {
			return;
		}

		if (this.isPcdIscedQualification()) {
			const pcdSubjectControl =
				this.educationDetailsForm.form.controls.pcdSubjectId;
			const selectedPcdSubjectId =
				this.educationDetailsForm.value.pcdSubjectId;

			if (this.isMissingIscedSubject(selectedPcdSubjectId)) {
				if (pcdSubjectControl) {
					pcdSubjectControl.setErrors({ required: true });
					pcdSubjectControl.markAsTouched();
				}
				this.sharedServices
					.openPopupDialog(
						"ERROR",
						this.getIscedValidationMessage(),
						HEC_CONSTANTS.ERROR_TYPES.error
					)
					.then(() => {});
				return;
			}
		}

		if (this.validate(this.educationDetailsForm)) {
			localStorage.setItem(
				"name",
				encrypt(this.educationDetailsForm.value.nameOnDegree)
			);
			this.nameService.setNameOnDegree(
				this.educationDetailsForm.value.nameOnDegree
			);
			this.loader = true;
			this.loaderService.setValue(this.loader);
			this.cdr.detectChanges();
			let payload = {
				data: this.educationDetailsForm.value,
			};
			if (this.qualId == 7 || this.qualId == 8) {
				payload.data.gradingSystemCodeId = 10543;
			}
			payload.data.qualificationLevelCode = payload.data.qualificationId;
			payload.data.educationId = this.educationDetailsData.educationId;
			payload.data.activeIndicator = true;
			delete payload.data.nameOnDegree;
			delete payload.data.searchCtrl;
			payload.data.isPortal = true;
			payload.data.isResearchWork =
				payload.data.isResearchWork == "Yes" ? true : false;
			payload.data.startDate =
				new Date(payload.data.startDate).getFullYear() +
				"-" +
				(new Date(payload.data.startDate).getMonth() + 1) +
				"-" +
				new Date(payload.data.startDate).getDate();
			payload.data.endDate =
				new Date(payload.data.endDate).getFullYear() +
				"-" +
				(new Date(payload.data.endDate).getMonth() + 1) +
				"-" +
				new Date(payload.data.endDate).getDate();

			let pcdSubjectId = payload.data.pcdSubjectId;

			delete payload.data.pcdSubjectId;

			if(!this.isPCD)
			{
					this.sharedServices.saveOrUpdateEducation(payload).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.isAlertVisible = false;
							// this.getEducationDetails();
							let emitData = {
								statusCode: res.statusCode,
								id: payload.data.educationId,
								res: this.applicationId,
							};
							this.educationUpdated.emit(emitData);

							//it is emitting from here
							// this.parentFunction.emit("emite");
							console.log(this.applicationId);

							if (this.isPcdIscedQualification()) {
								let payload1 = {
									id: this.applicationId,
									pcdSubjectId: pcdSubjectId,
									titleOfDissertation:
										this.educationDetailsForm.value
											.titleOfDissertation,
									universityId:
										this.educationDetailsForm.value
											.universityId,
									universitySector:
										this.educationDetailsForm.value.sectorCode,
									departmentId:
										this.educationDetailsForm.value
											.universityDepartmentId,
									subject:
										this.educationDetailsForm.value
											.specializationSubjectId,
									disciplineId:
										this.educationDetailsForm.value.subjectId,
									status: this.pcdStatus,
									universityCampusId:
										this.educationDetailsForm.value.campusId,
								};

								console.log(payload1);

								this.sharedServices
									.pcdSaveApplication(payload1)
									.subscribe(async (res: HecResponse) => {
										if (
											res.statusCode ==
											HEC_CONSTANTS.HTTP_RESPONSE.OK
										) {
											this.parentFunction.emit("emi");
											console.log(res);
											this.applicationId = res.data;

											//this.cdr.detectChanges();

											//not working
											//this.applicationIdNew.emit(this.applicationId);

											// this.pcdComponent.applicationId = this.applicationId;
											// console.log(this.pcdComponent)
											localStorage.setItem(
												"pcdId",
												this.applicationId
											);
											let a = localStorage.getItem("pcdId");

											console.log(a);

											//????? not working from here ????
											// let data1 = {
											// 	appId: '1',
											// 	pcdSubject: '2'
											// };
											// await this.parentFunction.emit(data1);

											if (
												this.applicationId != null &&
												this.applicationId != undefined
											) {
												this.getPcdSubject();
											}
										} else {
											// let data1 = {
											// 	appId: '1',
											// 	pcdSubject: '2'
											// };
											// this.parentFunction.emit(data1);
											this.loaderService.setValue(false);
											this.alertMsgValue =
												HEC_CONSTANTS.MESSGAES_LIST.profileMessages.SOMETHING_WENT_WRONG;
											//	this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
											// this.isAlertVisible = true;
											this.sharedServices
												.openPopupDialog(
													"ERROR",
													HEC_CONSTANTS.MESSGAES_LIST
														.profileMessages
														.SOMETHING_WENT_WRONG,
													HEC_CONSTANTS.ERROR_TYPES.error
												)
												.then((res) => {});
											this.cdr.detectChanges();
										}
									});
							}
						} else {
							this.loader = false;
							this.loaderService.setValue(this.loader);
							this.isAlertVisible = true;
							this.alertBoxMsg(
								HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
									.ERROR_SUBMITTING
							);
							this.cdr.detectChanges();
							setTimeout(() => {
								this.isAlertVisible = false;
								this.cdr.detectChanges();
							}, 3000);
						}
					},
					(err) => {
						this.isAlertVisible = true;
						this.alertBoxMsg(
							HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
								.ERROR_SUBMITTING
						);
						this.loader = false;
						this.loaderService.setValue(this.loader);
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				);
			}
			else if(this.isPCD)
			{
				this.sharedServices.saveOrUpdatePCDEducation(this.pcdProfileId, payload).subscribe(
					(res: HecResponse) => {
						if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
							this.isAlertVisible = false;
							// this.getEducationDetails();
							let emitData = {
								statusCode: res.statusCode,
								id: payload.data.educationId,
								res: this.applicationId,
							};
							this.educationUpdated.emit(emitData);

							//it is emitting from here
							// this.parentFunction.emit("emite");
							console.log(this.applicationId);

							if (this.isPcdIscedQualification()) {
								let payload1 = {
									id: this.applicationId,
									pcdSubjectId: pcdSubjectId,
									titleOfDissertation:
										this.educationDetailsForm.value
											.titleOfDissertation,
									universityId:
										this.educationDetailsForm.value
											.universityId,
									universitySector:
										this.educationDetailsForm.value.sectorCode,
									departmentId:
										this.educationDetailsForm.value
											.universityDepartmentId,
									subject:
										this.educationDetailsForm.value
											.specializationSubjectId,
									disciplineId:
										this.educationDetailsForm.value.subjectId,
									status: this.pcdStatus,
									universityCampusId:
										this.educationDetailsForm.value.campusId,
								};

								console.log(payload1);

								this.sharedServices
									.pcdSaveApplication(payload1)
									.subscribe(async (res: HecResponse) => {
										if (
											res.statusCode ==
											HEC_CONSTANTS.HTTP_RESPONSE.OK
										) {
											this.parentFunction.emit("emi");
											console.log(res);
											this.applicationId = res.data;

											//this.cdr.detectChanges();

											//not working
											//this.applicationIdNew.emit(this.applicationId);

											// this.pcdComponent.applicationId = this.applicationId;
											// console.log(this.pcdComponent)
											localStorage.setItem(
												"pcdId",
												this.applicationId
											);
											let a = localStorage.getItem("pcdId");

											console.log(a);

											//????? not working from here ????
											// let data1 = {
											// 	appId: '1',
											// 	pcdSubject: '2'
											// };
											// await this.parentFunction.emit(data1);

											if (
												this.applicationId != null &&
												this.applicationId != undefined
											) {
												this.getPcdSubject();
											}
										} else {
											// let data1 = {
											// 	appId: '1',
											// 	pcdSubject: '2'
											// };
											// this.parentFunction.emit(data1);
											this.loaderService.setValue(false);
											this.alertMsgValue =
												HEC_CONSTANTS.MESSGAES_LIST.profileMessages.SOMETHING_WENT_WRONG;
											//	this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
											// this.isAlertVisible = true;
											this.sharedServices
												.openPopupDialog(
													"ERROR",
													HEC_CONSTANTS.MESSGAES_LIST
														.profileMessages
														.SOMETHING_WENT_WRONG,
													HEC_CONSTANTS.ERROR_TYPES.error
												)
												.then((res) => {});
											this.cdr.detectChanges();
										}
									});
							}
						} else {
							this.loader = false;
							this.loaderService.setValue(this.loader);
							this.isAlertVisible = true;
							this.alertBoxMsg(
								HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
									.ERROR_SUBMITTING
							);
							this.cdr.detectChanges();
							setTimeout(() => {
								this.isAlertVisible = false;
								this.cdr.detectChanges();
							}, 3000);
						}
					},
					(err) => {
						this.isAlertVisible = true;
						this.alertBoxMsg(
							HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
								.ERROR_SUBMITTING
						);
						this.loader = false;
						this.loaderService.setValue(this.loader);
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				);
			}
		} else {
			if (this.findInvalidControls().length > 0) {
				let fields = this.findInvalidControls().join(", ");
				this.alertBoxMsg(
					HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
						.MANDATORY_MSG
				);
				this.isAlertVisible = true;
				this.cdr.detectChanges();
			}
		}
	}

	public saveDesfEducation() {
		this.markFormsTouched(this.educationDetailsForm);
		if (!this.enforceUniversityDepartmentRequired()) {
			return;
		}
		if (this.validate(this.educationDetailsForm)) {
			localStorage.setItem(
				"name",
				encrypt(this.educationDetailsForm.value.nameOnDegree)
			);
			this.nameService.setNameOnDegree(
				this.educationDetailsForm.value.nameOnDegree
			);
			this.loader = true;
			this.loaderService.setValue(this.loader);
			this.cdr.detectChanges();

			// if(this.qualId == 7 || this.qualId == 8){
			//   payload.data.gradingSystemCodeId = 10543;
			// }
			// payload.data.qualificationLevelCode = payload.data.qualificationId
			// payload.data.educationId = this.educationDetailsData.educationId
			// payload.data.activeIndicator = true;
			delete this.educationDetailsForm.value.nameOnDegree;
			delete this.educationDetailsForm.value.searchCtrl;
			// payload.data.isResearchWork = payload.data.isResearchWork == 'Yes' ? true:false;
			this.educationDetailsForm.value.startDate =
				new Date(
					this.educationDetailsForm.value.startDate
				).getFullYear() +
				"-" +
				(new Date(
					this.educationDetailsForm.value.startDate
				).getMonth() +
					1) +
				"-" +
				new Date(this.educationDetailsForm.value.startDate).getDate();
			this.educationDetailsForm.value.endDate =
				new Date(
					this.educationDetailsForm.value.endDate
				).getFullYear() +
				"-" +
				(new Date(this.educationDetailsForm.value.endDate).getMonth() +
					1) +
				"-" +
				new Date(this.educationDetailsForm.value.endDate).getDate();
			let payload1 = {};
			let payload = {
				data: {
					qualification:
						this.educationDetailsForm.value.qualification,
					startDate: this.educationDetailsForm.value.startDate,
					endDate: this.educationDetailsForm.value.endDate,
					country: this.educationDetailsForm.value.country,
					university: this.educationDetailsForm.value.university,
					campus: this.educationDetailsForm.value.campus,
					department: this.educationDetailsForm.value.department,
					modeOfStudy: this.educationDetailsForm.value.modeOfStudy,
					rollNo:
						this.educationDetailsForm.value.rollNo !== null
							? this.educationDetailsForm.value.rollNo
							: "",
					major: this.educationDetailsForm.value.major,
					sessionType: this.educationDetailsForm.value.sessionType,
					degreeObtainedBy:
						this.educationDetailsForm.value.degreeObtainedBy,
					researchTitle:
						this.educationDetailsForm.value.researchTitle !== null
							? this.educationDetailsForm.value.researchTitle
							: "",
					exactDegreeName:
						this.educationDetailsForm.value.exactDegreeName,
					discipline: this.educationDetailsForm.value.discipline,
					pmdcRegistration:
						this.educationDetailsForm.value.pmdcRegistration,
					id: this.educationDetailsData
						? this.educationDetailsData.id
						: undefined,
				},
			};
			//   if(this.educationDetailGridData.length == 0 && !this.educationDetailsData.id){
			//   payload1 = {
			//     desDegree: [this.educationDetailsForm.value]
			//   }

			//   payload = {
			//     data:payload1
			//   };
			// }else if(this.educationDetailGridData.length > 0 && this.educationDetailsData.id){
			//   console.log(
			//     this.educationDetailGridData
			//   )
			//   this.educationDetailGridData.forEach(element => {
			//     if(element.desDegree.id == this.educationDetailsData.id){
			//       // payload1 = {
			//       //   desDegree: [{
			//         element.desDegree.campus= this.educationDetailsForm.value.campus;
			//         element.desDegree.country= this.educationDetailsForm.value.country;
			//         element.desDegree.degreeObtainedBy= this.educationDetailsForm.value.degreeObtainedBy;
			//         element.desDegree.department= this.educationDetailsForm.value.department;
			//         element.desDegree.endDate= this.educationDetailsForm.value.endDate;
			//         element.desDegree.exactDegreeName= this.educationDetailsForm.value.exactDegreeName;
			//         element.desDegree.major= this.educationDetailsForm.value.major;
			//         element.desDegree.modeOfStudy= this.educationDetailsForm.value.modeOfStudy;
			//         element.desDegree.qualification= this.educationDetailsForm.value.qualification;
			//         element.desDegree.researchTitle= this.educationDetailsForm.value.researchTitle;
			//         element.desDegree.rollNo= this.educationDetailsForm.value.rollNo;
			//         element.desDegree.sessionType= this.educationDetailsForm.value.sessionType;
			//         element.desDegree.startDate= this.educationDetailsForm.value.startDate;
			//         element.desDegree.university= this.educationDetailsForm.value.university;
			//         element.desDegree.desApplicationId = this.applicationId;
			//         element.desDegree.id=element.desDegree.id;
			//       //   }]
			//       // }
			//     }else{
			//       element.desDegree.desApplicationId = this.applicationId;
			//     }
			//   });

			//   let eduRecords = [];
			//   this.educationDetailGridData.forEach(element => {
			//     eduRecords.push(element.desDegree)
			//   });

			//   payload1= {
			//       onCampusDegree: this.onCampusDegree ? this.onCampusDegree:false,
			//       passportAvailable: this.passportAvailable ? this.passportAvailable:false,
			//       id:this.applicationId,
			//       desDegree:eduRecords
			//   }
			//   payload = {
			//     data:payload1
			//   };
			// }else if(this.educationDetailGridData.length > 0 && !this.educationDetailsData.id){
			//   let eduRecords = [];
			//   this.educationDetailGridData.forEach(element => {
			//     element.desDegree.desApplicationId = this.applicationId
			//     eduRecords.push(element.desDegree)
			//   });

			//   eduRecords.push({
			//         campus: this.educationDetailsForm.value.campus,
			//         country: this.educationDetailsForm.value.country,
			//         degreeObtainedBy: this.educationDetailsForm.value.degreeObtainedBy,
			//         department: this.educationDetailsForm.value.department,
			//         endDate: this.educationDetailsForm.value.endDate,
			//         exactDegreeName: this.educationDetailsForm.value.exactDegreeName,
			//         major: this.educationDetailsForm.value.major,
			//         modeOfStudy:this.educationDetailsForm.value.modeOfStudy,
			//         qualification: this.educationDetailsForm.value.qualification,
			//         researchTitle: this.educationDetailsForm.value.researchTitle,
			//         rollNo: this.educationDetailsForm.value.rollNo,
			//         sessionType: this.educationDetailsForm.value.sessionType,
			//         startDate: this.educationDetailsForm.value.startDate,
			//         university: this.educationDetailsForm.value.university,
			//         desApplicationId: this.applicationId,
			//   })

			//   payload1= {
			//     onCampusDegree: this.onCampusDegree ? this.onCampusDegree:false,
			//     passportAvailable: this.passportAvailable ? this.passportAvailable:false,
			//     id:this.applicationId,
			//     desDegree:eduRecords
			//   }
			//   payload = {
			//     data:payload1
			//   };
			// }
			this.educationDetailsService.saveDesfDetails(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.isAlertVisible = false;
						// this.getEducationDetails();
						let emitData = {
							statusCode: res.statusCode,
							res: res.data.Id,
							id: this.educationDetailsData.id,
						};
						this.educationUpdated.emit(emitData);
					} else {
						this.loader = false;
						this.loaderService.setValue(this.loader);
						this.isAlertVisible = true;
						this.alertBoxMsg(
							HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
								.ERROR_SUBMITTING
						);
						this.cdr.detectChanges();
						setTimeout(() => {
							this.isAlertVisible = false;
							this.cdr.detectChanges();
						}, 3000);
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertBoxMsg(
						HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
							.ERROR_SUBMITTING
					);
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
					setTimeout(() => {
						this.isAlertVisible = false;
						this.cdr.detectChanges();
					}, 3000);
				}
			);
		} else {
			if (this.findInvalidControls().length > 0) {
				let fields = this.findInvalidControls().join(", ");
				this.alertBoxMsg(
					HEC_CONSTANTS.MESSGAES_LIST.educationalMessages
						.MANDATORY_MSG
				);
				this.isAlertVisible = true;
				this.cdr.detectChanges();
			}
		}
	}

	public getDegreeObtainedBy(value) {
		if (value == 6003802 || value == 6003803) {
			this.isResearchRequired = true;
		} else {
			this.isResearchRequired = false;
		}
	}

	public findInvalidControls() {
		const invalid = [];
		const controls = this.educationDetailsForm.form.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	}

	private alertBoxMsg(message, alertType?) {
		if (alertType == "success") {
			this.alertClass =
				"alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fa fa-check-circle";
		} else if (alertType == "warning") {
			this.alertClass =
				"alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fas fa-exclamation-circle";
		} else {
			this.alertClass =
				"alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fa fa-exclamation-triangle";
		}
		this.alertMsgValue = message;
	}

	public gotoHelp(): void {
		window.open("https://onlinehelp.hec.gov.pk/");
	}

	public gotoFocalPerson(): void {
		window.open(
			"https://hec.gov.pk/english/services/universities/pqr/Pages/HEIs-Focal-Persons.aspx"
		);
	}

	public getDesForeignEducationLists() {
		return new Promise((resolve, reject) => {
			this.educationDetailsService
				.getDesForeignDropdowns()
				.subscribe((res) => {
					if (res.statusCode == 200) {
						this.qualificationLevel = res.data["60035"];
						this.dropdownList.degreeTypesList = res.data["60036"];
						this.dropdownList.sessionTypesList = res.data["60037"];
						this.dropdownList.examSystemTypeList =
							res.data["60038"];
						// this.dropdownList.countryList.splice(139, 1);
						var indexOfPakistan =
							this.dropdownList.countryList.findIndex(
								(d) => d.value == 1
							); //not required for foreign education
						// this.dropdownList.countryList.splice(
						// 	indexOfPakistan,
						// 	1
						// );
						console.log(indexOfPakistan);

						resolve(this.qualificationLevel);
						this.cdr.detectChanges();
						console.log(res.data);
					}
				});
		}).catch(function (error) {
			console.log(error);
		});
	}
	public getPcdSubjectList() {
		this.loader = true;
		this.loaderService.setValue(this.loader);
		this.cdr.detectChanges();

		return new Promise((resolve, reject) => {
			this.educationDetailsService
				.getPCDSubjectListDropdown()
				.subscribe((res: HecResponse) => {
					this.loader = false;
					this.loaderService.setValue(this.loader);
					this.cdr.detectChanges();
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						this.pcdSubjectList = res.data;
						resolve(this.pcdSubjectList);
						this.cdr.detectChanges();
					}
				});
		}).catch(function (error) {
			console.log(error);
		});
	}

	public getPcdSubject() {
		this.educationDetailsService
			.getPcdSubject(this.applicationId)
			.subscribe((res: HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					console.log(res);
					this.pcdSubjectSpecialization =
						res.data.pcdStudentApplicationDto.pcdSubjectId;
					console.log(this.pcdSubjectSpecialization);
				} else {
					this.loaderService.setValue(false);
					this.alertMsgValue =
						HEC_CONSTANTS.MESSGAES_LIST.profileMessages.SOMETHING_WENT_WRONG;
					//	this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					// this.isAlertVisible = true;
					this.sharedServices
						.openPopupDialog(
							"ERROR",
							HEC_CONSTANTS.MESSGAES_LIST.profileMessages
								.ERROR_EDUCATION_DELETE,
							HEC_CONSTANTS.ERROR_TYPES.error
						)
						.then((res) => {});
					this.cdr.detectChanges();
				}
			});
	}
}
